import React, { useEffect, useRef, useState } from "react";
import { CashInOut } from "../../Api";
import { URLS } from "../../API/API endpoints";
import axiosInstance from "../../AxiosInstance";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import NumericKeyboardModal from "../Modal/NumericKeyboard"; // adjust path
import AlphaNumericKeyboardModal from "./AlphaNumericKeyboardModal";
import { detectWebDeviceType, isTablet } from "../../utils";
import { logButtonClick } from "../../API/API Functions/ProductRequest_API";
import { Select } from "antd";
import i18next from "i18next";

const { Option } = Select;

function InputField({
  label,
  placeholder,
  value,
  onChange,
  type = "text",
  onEnterPress,
  inputRef,
  readOnly,
  onFocus,
  focused,
}) {
  const deviceType = detectWebDeviceType();
  const { t, i18n } = useTranslation();

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && typeof onEnterPress === "function") {
      e.preventDefault();
      onEnterPress();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && typeof onEnterPress === "function") {
      e.preventDefault();
      onEnterPress(); // Triggers handleConfirm
    }
  };

  return (
    <>
      <div className="mt-9 font-medium max-md:max-w-full">{t(label)}</div>
      <div
        className={`flex border rounded-xl overflow-hidden justify-center items-start transition-colors duration-200 ${i18n.language === "ar" ? "flex-row-reverse" : ""
          }
           ${deviceType === "tablet" && focused ? "" : ""}`} // ✅ Tablet-only blue border
      >
        {label === "Amount" && (
          <span className="pl-3 py-3 bg-white  text-black max-md:pe-3">
            EGP
          </span>
        )}
        <input
          ref={inputRef}
          type={type}
          placeholder={t(placeholder)}
          value={value}
          readOnly={readOnly}
          onFocus={onFocus}
          style={{
            direction: "ltr",
            caretColor:  undefined,
          }}
          onChange={(e) => onChange(e.target.value)}
          // onKeyPress={handleKeyPress}
          onKeyDown={handleKeyDown}
          onBlur={(e) => {
            if (onChange) {
              onChange(e.target.value);
            }
          }}
          className="p-3 bg-white rounded-xl text-left border-0 border-neutral-400 border-opacity-50  max-md:pr-5 max-md:max-w-full w-full focus:outline-none focus:border-2px"
        />
      </div>
    </>
  );
}

function CashIn_Modal({ onClose, title, handleSubmit }) {
  const deviceType = detectWebDeviceType();

  const { t, i18n } = useTranslation();
  const [amount, setAmount] = useState("");
  const [reason, setReason] = useState("");
  const userData = useSelector((state) => state?.login?.user?.result);
  const lastCallTime = React.useRef(0);
  const amountInputRef = useRef(null);
  const [hasConfirmed, setIshasConfirmed] = useState(false);
  const [isTransactionInProgress, setIsTransactionInProgress] = useState(false);
  const [dashboardData, setDashboardData] = useState({});
  const cashDifference = dashboardData?.cash_difference;
  const [showKeyboard, setShowKeyboard] = useState(false);
  const [keyboardMode, setKeyboardMode] = useState("numeric"); // or "alphanumeric"
  const [focusedField, setFocusedField] = useState(""); // 'amount' or 'reason'
  const [expenseType, setExpenseType] = useState("");
  const [expenseTypes, setExpenseTypes] = useState([]);
  const [loadingTypes, setLoadingTypes] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const [pendingReason, setPendingReason] = useState("");
  const reasonRef = useRef("");
  const reasonInputRef = useRef(null);

  const handleCustomKeyPress = (key) => {
    if (keyboardMode === "numeric") {
      if (key === "DEL") {
        setAmount((prev) => prev.slice(0, -1));
      } else {
        const newVal = amount + key;
        if (newVal.match(/^\d*\.?\d{0,2}$/) && parseFloat(newVal) < 10000000) {
          setAmount(newVal);
        }
      }
    } else {
      if (key === "DEL") {
        setReason((prev) => prev.slice(0, -1));
      } else if (key === "SPACE") {
        setReason((prev) => prev + " ");
      } else {
        setReason((prev) => prev + key);
      }
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      // setLoading(true)
      const response = await axiosInstance.post(URLS.OPEN_SESSION_INFO, {
        user_id: userData?.user_id,
        company_id: userData?.company_id,
      });
      if (response?.data?.result?.status === 200) {
        setDashboardData(response?.data?.result?.response[0]);
      }
    } catch (err) {
      console.error(err);
    } finally {
      // setLoading(false)
    }
  };

  useEffect(() => {
    if (amountInputRef.current) {
      amountInputRef.current.focus();
    }
  }, []);

  let timeoutId = null;

  const handleConfirm = async (overrideReason) => {
    console.log("Handle Confirm Called");


    if (isTransactionInProgress) return;
    setIsTransactionInProgress(true);

    const finalReason = overrideReason ?? reason;

    if (!finalReason || finalReason.trim() === "") {
      toast.error(t("Reason is required."));
      setIsTransactionInProgress(false);
      return;
    }



    try {
      const delay = 500;
      if (Date.now() - lastCallTime.current < delay) {
        return;
      }
      lastCallTime.current = Date.now();

      let value;
      if (title === "Cash In") {
        value = parseFloat(amount);
      } else {
        value = -parseFloat(amount);
      }

      if (isNaN(value)) {
        toast.error("Amount must be a valid number");
        return;
      }

      if (typeof cashDifference === "undefined") {
        toast.error(t("Cash difference is not available."));
        return;
      }

      if (title === "Cash Out" && parseFloat(amount) > -cashDifference) {
        return;
      }

      // let finalReason = overrideReason ?? reason;


      const response = await axiosInstance.post(URLS.CASH_IN_OUT, {
        session_id: userData?.session_id,
        type: title === "Cash In" ? "cash_in" : "cash_out",
        amount: value,
        reason: finalReason,
        is_refund_with_new: false,
        is_credit_order: false,
        lang: i18next.language === "ar" ? "ar_001" : "en_US",
      });

      if (response?.data?.result?.status_code === 200) {
        handleSubmit();
        setIsTransactionInProgress(false);
        setIshasConfirmed(false);
        logButtonClick(userData?.user_id, userData?.company_id, title);
      }
    } catch (error) {
      setIsTransactionInProgress(false);
      console.error("Error:", error);
    }
  };
  const handleKeyDown = (e) => {

    if (!reason || reason.trim() === "") {
      // toast.error(t("Reason is required."));
      setIsTransactionInProgress(false);
      return;
    }


    if (e.key === "Escape") {
      onClose();
    }
    if (e.key === "Tab" && isDropdownOpen) {
      e.preventDefault();
    }

    if (
      e.key === "Enter" &&
      !hasConfirmed &&
      !isTransactionInProgress &&
      !isDropdownOpen
    ) {
      e.preventDefault();
      const latestReason =
        reasonInputRef.current?.value ?? reasonRef.current ?? reason;
      setIshasConfirmed(true);
      setIsTransactionInProgress(true);
      handleConfirm(latestReason);
    }
  };

  useEffect(() => {
    if (title === "Cash Out") {
      fetchExpenseTypes();
    }
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [amount, cashDifference, isTransactionInProgress, hasConfirmed, title, reason]);

  // Updated onChange handler for reason input field
  const handleReasonChange = (e) => {
    const newReason = e.target.value; // The reason typed in the input field
    setReason(newReason);
  };

  const getExpenseTypes = async (company_id) => {
    try {
      let lang = i18n.language;

      if (lang === "ar") {
        lang = "ar";
      } else if (lang === "en") {
        lang = "en_US";
      }

      const payload = { company_id, lang };
      const response = await axiosInstance.post(
        URLS.GET_EXPENSE_TYPES,
        payload
      );

      return response.data;
    } catch (error) {
      return error;
    }
  };

  const fetchExpenseTypes = async () => {
    try {
      setLoadingTypes(true);
      const res = await getExpenseTypes(userData?.company_id);
      const types = res?.result?.expense_types || [];
      setExpenseTypes(types);
      setLoadingTypes(false);
    } catch (err) {
      console.error(err);
      setLoadingTypes(false);
    }
  };

  useEffect(() => {
    reasonRef.current = reason;
  }, [reason]);
  return (
     <div className={`fixed top-0 left-0 w-full h-full flex justify-center z-50 backdrop-blur-md drop-shadow-sm
 ${deviceType == 'tablet' ? "pt-24" : "items-center"}`}>
  <div className="fixed top-0 left-0 w-full h-full bg-black opacity-50 z-40"></div>
 <section
 className={` flex flex-col px-12 py-12 text-lg font-semibold leading-6 h-fit bg-white rounded-[25px] text-zinc-800 max-md:px-5 z-50 ${"relative "
}`}
 style={{ width: "600px" }}
  >
        <header className="flex gap-5 text-3xl max-md:flex-wrap max-md:max-w-full">
          <h1 className="flex-auto my-auto">{t(title)}</h1>
          <button
            type="button"
            onClick={onClose}
            className="absolute top-4 right-3 text-zinc-800 bg-transparent"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </header>
        <main>
          <InputField
            label="Amount"
            placeholder="Enter Amount"
            value={amount}
            type="number"
            // readOnly={deviceType === "tablet"}
            onFocus={() => {
              // if (deviceType === "tablet") {
              //   setKeyboardMode("numeric");
              //   setShowKeyboard(true);
              //   setFocusedField("amount");
              // }
            }}
            focused={focusedField === "amount"}
            inputRef={amountInputRef}
            onEnterPress={() => {
              const latestReason =
                reasonInputRef.current?.value ?? reasonRef.current ?? reason;
              title === "Cash Out" && parseFloat(amount) > -cashDifference
                ? toast.error(t("Not enough cash"))
                : handleConfirm(latestReason);
            }}
            onChange={(value) => {
              value = value.replace(/ز/g, ".");

              if (value.match(/^\d*\.?\d{0,2}$/) && value < 10000000) {
                setAmount(value);
              }
            }}
          />

          {title === "Cash Out" && (
            <>
              <p className="mt-6 mb-2 font-normal ">
                {t("Select Expense Type")}
              </p>
              <Select
                style={{
                  width: "100%",
                  backgroundColor: "white",
                  fontSize: "20px",
                  fontWeight: "bold",
                }}
                dropdownStyle={{ fontSize: "20px" }}
                placeholder={t("Select Expense Type")}
                value={expenseType}
                onChange={(value) => {
                  setExpenseType(value);
                  if (value !== "Other") {
                    setReason(value);
                    reasonRef.current = value; // <-- keep in sync
                  } else {
                    setReason("");
                    reasonRef.current = "";
                  }
                }}
                onSearch={(value) => setExpenseType(value)}
                showSearch
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
                notFoundContent={loadingTypes ? t("Loading...") : t("")}
                className="custom-select"
                popupClassName="custom-select-dropdown"
                onDropdownVisibleChange={(open) => {
                  setIsDropdownOpen(open);

                  if (!open) {
                    // Add a small delay to let the state update
                    setTimeout(() => {
                      if (hasConfirmed && !isTransactionInProgress) {
                        const latestReason =
                          reasonInputRef.current?.value ??
                          reasonRef.current ??
                          reason;
                        handleConfirm(latestReason);
                      }
                    }, 150); // 150ms is enough to let state update
                  }
                }}
              >
                {expenseTypes.map((type) => (
                  <Option
                    style={{
                      fontSize: "20px",
                    }}
                    key={type.id}
                    value={type.name}
                    className="text-normal"
                  >
                    {t(type.name)}
                  </Option>
                ))}
                <Option
                  style={{
                    fontSize: "20px",
                  }}
                  key="Other"
                  value="Other"
                  className="text-normal"
                >
                  {t("Other")}
                </Option>
              </Select>
            </>
          )}

          {title !== "Cash Out" || expenseType === "Other" ? (
            <InputField
              label="Reason"
              placeholder="Enter Reason"
              value={reason}
              type="text"
              // readOnly={deviceType === "tablet"} // only readOnly on tablet
              onFocus={() => {
                // if (deviceType === "tablet") {
                //   setKeyboardMode("alphanumeric");
                //   setShowKeyboard(true);
                //   setFocusedField("reason");
                // }
              }}
              focused={focusedField === "reason"}
              onEnterPress={() => {
                if (focusedField === "reason") {
                  document.activeElement.blur(); // force onBlur to trigger
                  reasonRef.current = reason;
                }

                if (
                  title === "Cash Out" &&
                  parseFloat(amount) > -cashDifference
                ) {
                  toast.error(t("Not enough cash"));
                } else {
                  const latestReason =
                    reasonInputRef.current?.value ??
                    reasonRef.current ??
                    reason;
                  handleConfirm(latestReason);
                }
              }}
              onChange={setReason}
            />
          ) : null}
        </main>
        <footer>
          <button
            disabled={amount <= 0 || !reason.trim()}
            className={`justify-center items-center px-16 py-3.5 mt-16 text-xl text-center text-white capitalize whitespace-nowrap bg-[#7EC242] rounded-lg max-md:px-5 max-md:mt-10 max-md:max-w-full`}
            style={{
              width: "500px",
              opacity: amount > 0 && reason.trim() ? 1 : 0.5,
              // opacity: amount > 0 ? 1 : 0.5 
            }}
            onClick={() => {
              title === "Cash Out" && parseFloat(amount) > -cashDifference
                ? toast.error(t("Not enough cash"))
                : handleConfirm(
                  reasonInputRef.current?.value ?? reasonRef.current ?? reason
                );
            }}
          >
            {t("Confirm")}
          </button>
        </footer>
      </section>
      {/* {deviceType === "tablet" && showKeyboard && (
        <AlphaNumericKeyboardModal
          onClose={() => setShowKeyboard(false)}
          onKeyPress={handleCustomKeyPress}
          mode={keyboardMode}
          width="42%"
          maxWidth="42%"
          maxHeight="54%"
        />
      )} */}
    </div>
  );
}

export default CashIn_Modal;
